import React from 'react';
export default function Th(_a) {
    var width = _a.width, label = _a.label, children = _a.children, _b = _a.aling, aling = _b === void 0 ? 'center' : _b, orden = _a.orden, by = _a.by, setOrden = _a.setOrden;
    function Flechas() {
        if (by === label)
            if (orden === 'desc')
                return React.createElement("i", { className: 'fa fa-arrow-up' });
            else
                return React.createElement("i", { className: 'fa fa-arrow-down' });
        return React.createElement(React.Fragment, null);
    }
    function colorOrden() {
        if (by === label) {
            return '#afd9ee';
        }
        return '#bfe9fe';
    }
    return (React.createElement("th", { style: {
            width: width,
            maxWidth: width,
            minHeight: width,
            textAlign: aling,
            backgroundColor: colorOrden()
        }, onClick: function () {
            if (label && setOrden)
                if (by === label) {
                    if (orden === 'asc')
                        setOrden({ orden: 'desc' });
                    else
                        setOrden({ orden: 'asc' });
                }
                else {
                    setOrden({ orden: 'desc', by: label });
                }
        } },
        children,
        " ",
        React.createElement(Flechas, null)));
}
//# sourceMappingURL=Th.js.map